var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import { RETURN_METHOD } from '../constants/general';
export var ReturnAllowedMap = (_a = {},
    _a[RETURN_METHOD.UPS_DROP_OFF] = 'returnDropoffAllowed',
    _a[RETURN_METHOD.IN_STORE] = 'returnInStoreAllowed',
    _a[RETURN_METHOD.LORP] = 'returnLORPAllowed',
    _a);
export var CheckEligibilityMap = (_b = {},
    _b[RETURN_METHOD.UPS_DROP_OFF] = 'returnEligible',
    _b[RETURN_METHOD.IN_STORE] = 'sorisReturnEligible',
    _b[RETURN_METHOD.LORP] = 'lorpReturnEligible',
    _b);
// DEPRECATED: Converting array to dictionary for easier traversal
export var convertReturnEligibilityItemsToDict = function (lineItems, eligibilityType) {
    if (lineItems === void 0) { lineItems = []; }
    return lineItems.reduce(function (obj, item) {
        var _a;
        return (__assign(__assign({}, obj), (_a = {}, _a[item.lineNumber] = item[eligibilityType] || false, _a)));
    }, {});
};
/**
 * Checks if lineItems are eligible for returns based on OMS eligibility and CheckEligibilityAPI response.
 * @param item Line item from order details
 * @param itemCheckEligibility Boolean indicating if the item is eligible based on CheckEligibilityAPI
 * @param eligibilityField Field to check for OMS return eligibility
 */
export var isItemEligible = function (item, itemCheckEligibility, eligibilityField) {
    var omsReturnEligible = item[eligibilityField];
    if (eligibilityField === 'returnDropoffAllowed') {
        omsReturnEligible = Boolean(item.returnDropoffAllowed || item.returnOnlineAllowed);
    }
    if (omsReturnEligible === undefined) {
        return Boolean(itemCheckEligibility);
    }
    return omsReturnEligible && itemCheckEligibility;
};
/**
 * Mapper function to maintain existing flow in <ItemsToReturn>
 * @param lineItems lineItems from selected fulfillment group
 * @param returnEligibilityDetails API response frmo return/eligibility
 * @returns SingleItemFromReturnsApi object
 */
export var mapToSingleItemFromReturnsApiList = function (lineItems, returnEligibilityDetails, returnMethod) {
    var checkEligibilityField = CheckEligibilityMap[returnMethod];
    var returnAllowedField = ReturnAllowedMap[returnMethod];
    var returnEligibilityLineItemMap = ((returnEligibilityDetails === null || returnEligibilityDetails === void 0 ? void 0 : returnEligibilityDetails.lineItems) || []).reduce(function (itemMap, lineItem) {
        var _a;
        return __assign(__assign({}, itemMap), (_a = {}, _a[lineItem.lineNumber] = lineItem, _a));
    }, {});
    return lineItems.map(function (item) {
        var _a;
        var itemCheckElig = getItemCheckEligibility(returnEligibilityDetails === null || returnEligibilityDetails === void 0 ? void 0 : returnEligibilityDetails.lineItems, item.lineId, checkEligibilityField);
        var itemEligibility = isItemEligible(item, itemCheckElig, returnAllowedField);
        return {
            brandName: item.brandName,
            department: item.departmentNumber,
            isDFCSourced: item.isDFCSourced,
            classNumber: item.classId,
            itemCost: item.unitPrice || 0,
            shippingCharge: item.shippingCharge || 0,
            unitCost: item.unitCost,
            itemDescription: item.description,
            itemImageURL: item.imageUrl,
            itemSubClass: item.subClassId,
            lineItemId: item.lineId,
            mVendorNumber: item.vendorNumber,
            vendorPartNumber: item.vendorPartNumber,
            poNumber: item.PONumber,
            quantityOrdered: item.orginalOrderedQuantity,
            currentQuantity: item.currentQuantity,
            upcCode: item.upcCode,
            vendorName: item.vendorName,
            sku: item.skuNumber,
            omsId: item.omsId,
            secOmsId: item.secOmsId,
            returnEligibilityInfo: {
                returnEligible: itemEligibility,
            },
            hazmatItem: (_a = returnEligibilityLineItemMap[item.lineId]) === null || _a === void 0 ? void 0 : _a.hazmatItem,
            chargeIdentifier: item.chargeIdentifier,
            totalPrice: item.totalPrice,
            fulfillmentVendorNumber: item.fulfillmentVendorNumber,
            itemWeight: item.itemWeight,
            productType: item.productType,
            returnWindowEndDate: item.returnWindowEndDate,
            relationType: item.relationType,
            isStatusDeliveredOrOrderPickedup: item.isStatusDeliveredOrOrderPickedup === undefined
                ? true
                : item.isStatusDeliveredOrOrderPickedup,
        };
    });
};
var getItemCheckEligibility = function (lineItems, lineId, eligibilityField) {
    if (lineItems === void 0) { lineItems = []; }
    var item = lineItems.find(function (lineItem) { return lineItem.lineNumber === lineId; });
    if (!item)
        return false;
    return Boolean(item[eligibilityField]);
};
